import { Injectable } from '@angular/core';

declare function addLeadingZero(value: number): number;

@Injectable({
  providedIn: 'root'
})
export class DateService {

  getTimeStamp(): string {
    var currentDate = new Date();
    return '' + currentDate.getFullYear() + '' + currentDate.getMonth() + '' + currentDate.getDate() + '' + currentDate.getHours() + '' + currentDate.getMinutes() + '' + currentDate.getSeconds() + '' + currentDate.getMilliseconds();
  }

  onlyDateFromDateTimeString(dateTimeString: string): string {
    const dateTime = new Date(dateTimeString);
    return '' + addLeadingZero(dateTime.getDate()) + '.' + addLeadingZero((dateTime.getMonth() + 1)) + '.' + addLeadingZero(dateTime.getFullYear());
  }

}